/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyExpertEvaluation = {

	delete (context, expertEvaluationId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-expert-evaluation"
			+ "?expertEvaluationId=" + expertEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, expertEvaluationId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-expert-evaluation"
			+ "?expertEvaluationId=" + expertEvaluationId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-expert-evaluation/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency-expert-evaluation/contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postContestUsers (context, agencyProjectId, contestUserIds, onSuccess, onError, options) {
		Api.post(context,
			"/agency-expert-evaluation/contest-users"
			+ "?agencyProjectId=" + agencyProjectId
			, contestUserIds
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, expertEvaluationId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-expert-evaluation"
			+ "?expertEvaluationId=" + expertEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrection (context, evaluationId, correctionCauseDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-expert-evaluation/correction"
			+ "?evaluationId=" + evaluationId
			, correctionCauseDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, expertEvaluationId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/agency-expert-evaluation/data"
			+ "?expertEvaluationId=" + expertEvaluationId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, expertEvaluationId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/agency-expert-evaluation/finish"
			+ "?expertEvaluationId=" + expertEvaluationId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
